module.exports = __webpack_public_path__ + "static/modelo2-c7a7e96c369f8d791ada6c43c44fba7f.png";